import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemIntro } from './components/SystemIntro';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Capabilities } from './components/Capabilities';
import { Comparison } from './components/Comparison';
import { ResultsTestimonials } from './components/ResultsTestimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
export function App() {
  return <div className="w-full bg-cream text-ink" data-id="element-0" data-mp="28tw62tsgwo4i">
      <Navbar data-id="element-1" data-mp="28sl32w6ujkeg" />
      <main data-id="element-2" data-mp="28sbad0uf2z52">
        <Hero data-id="element-3" data-mp="23vcjqs9ypabm" />
        <PainPoints data-id="element-4" data-mp="23vkzcrxgytqi" />
        <SystemIntro data-id="element-5" data-mp="23u9u0nodldxa" />
        <Tomos data-id="element-6" data-mp="23ut9zyugts8o" />
        <Bonos data-id="element-7" data-mp="23t8fuac2cbbc" />
        <Offer data-id="element-8" data-mp="3ijxq4swlw4ky" />
        <Capabilities data-id="element-9" data-mp="3ikh8gaq64uzi" />
        <Comparison data-id="element-10" data-mp="3iiwfgpji5k3r" />
        <ResultsTestimonials data-id="element-11" data-mp="3ijfthv617oci" />
        <Guarantee data-id="element-12" data-mp="3mlja0y7k5j4n" />
        <Faq data-id="element-13" data-mp="3ml1419v3fqjj" />
        <FinalCta data-id="element-14" data-mp="3mkrgdsxitvh0" />
      </main>
      <Footer data-id="element-15" data-mp="3mjq1tehaqquj" />
      <StickyBar data-id="element-16" data-mp="3mjgczu7zmpqf" />
    </div>;
}